import { gql } from '@apollo/client';
import { useArticleContext } from './useArticleContext';
import {
  CategoryResponse,
  CmsCategory,
  cmsGraphql,
} from '@xolv-mybrightlink/common';

const CATEGORY_DISPLAY_FIRST: string[] = ['Getting Started'];

const FETCH_ARTICLE_CATEGORY = gql`
  query PostCategories {
    categories(first: 100) {
      nodes {
        databaseId
        name
        slug
      }
    }
  }
`;

export const useFetchArticleCategories = async () => {
  const [state, dispatch] = useArticleContext();
  if (state.initial) {
    const sortCategories = (categories: CmsCategory[] | null) => {
      if (categories === null) {
        return [];
      }
      const namedCategories = categories
        .filter((category) => category.slug != 'uncategorized')
        .sort((category1, category2) => {
          if (category1.name === null || category2.name === null) {
            return 0;
          }
          const category1Index = CATEGORY_DISPLAY_FIRST.indexOf(category1.name);
          const category2Index = CATEGORY_DISPLAY_FIRST.indexOf(category2.name);
          if (category1Index >= 0 && category2Index >= 0) {
            return category1Index - category2Index;
          } else if (category1Index >= 0 || category2Index >= 0) {
            return category2Index - category1Index;
          }
          return category1.name.localeCompare(category2.name);
        });

      const allCategoryTitle = 'All Articles';
      const allCategoryItem = {
        databaseId: -1,
        name: allCategoryTitle,
        slug: allCategoryTitle.toLowerCase(),
      };

      return [allCategoryItem, ...namedCategories];
    };

    const fetchCategories = async () => {
      const result = await cmsGraphql.query<CategoryResponse>({
        query: FETCH_ARTICLE_CATEGORY,
      });
      if (result.data.categories) {
        return sortCategories(result.data.categories.nodes);
      }
      return [];
    };
    const categories = await fetchCategories();
    dispatch({ type: 'category-fetched', categories });
  }
};
